import React, { FC, ReactNode, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import Colors from 'theme/colors';

interface Props {
  title: string;
  children: ReactNode;
  showBackToTools?: boolean;
  /** Extra header link back to TOEIC home (e.g. pronunciation discovery). */
  showBackToToeic?: boolean;
}

function getWin(): any {
  const g: any = typeof global !== 'undefined' ? global : {};
  return g.window || g;
}

const shell: any = {
  minHeight: '100vh',
  backgroundColor: Colors.SECOND_COLOR,
  fontFamily: 'sans-serif',
  color: Colors.TEXT,
};

const header: any = {
  backgroundColor: Colors.MAIN_COLOR,
  minHeight: 56,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 12px',
};

const backBtn: any = {
  background: 'transparent',
  border: 'none',
  color: Colors.WHITE,
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
  padding: '10px 6px',
  minWidth: 72,
  minHeight: 44,
  textAlign: 'left',
};

const toeicLink: any = {
  ...backBtn,
  minWidth: 72,
  textAlign: 'right',
};

const ToolLayout: FC<Props> = ({
  title,
  children,
  showBackToTools = true,
  showBackToToeic = false,
}) => {
  const history = useHistory();
  const [narrow, setNarrow] = useState(false);

  useEffect(() => {
    const win = getWin();
    const measure = () => {
      const w = (win.innerWidth != null ? win.innerWidth : 800) as number;
      setNarrow(w < 520);
    };
    measure();
    if (win.addEventListener) {
      win.addEventListener('resize', measure);
      return () => win.removeEventListener('resize', measure);
    }
    return undefined;
  }, []);

  const headerTitle: any = {
    color: Colors.WHITE,
    fontSize: narrow ? 16 : 18,
    fontWeight: 700,
    flex: 1,
    textAlign: 'center',
    margin: 0,
    padding: '0 4px',
  };

  const content: any = {
    maxWidth: 720,
    margin: '0 auto',
    padding: narrow ? '16px 12px 32px' : '20px 16px 40px',
  };

  const spacer: any = { minWidth: showBackToToeic || showBackToTools ? 72 : 48 };

  return (
    <div style={shell} data-no-ads="true">
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <header style={header}>
        {showBackToTools ? (
          <button
            type="button"
            style={backBtn}
            onClick={() => history.push('/tools')}
            aria-label="Về trang công cụ"
          >
            ← Công cụ
          </button>
        ) : (
          <div style={spacer} />
        )}
        <h1 style={headerTitle}>{title}</h1>
        {showBackToToeic ? (
          <button
            type="button"
            style={toeicLink}
            onClick={() => history.push('/')}
            aria-label="Về ôn TOEIC"
          >
            Ôn TOEIC
          </button>
        ) : (
          <div style={spacer} />
        )}
      </header>
      <main style={content}>{children}</main>
    </div>
  );
};

export default ToolLayout;
